import { render, staticRenderFns } from "./ResumeDetail.vue?vue&type=template&id=319b7db1&"
import script from "./ResumeDetail.vue?vue&type=script&lang=js&"
export * from "./ResumeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResumeDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports